<template>
    <div>
        上级精神
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="sass" scoped>

</style>